
import React,  { useEffect } from "react";
import ReactDOM from "react-dom";
import './products_dropdown.scss';

const ProductsDropdownComponent = () => {
    useEffect(() => {
        try{
            const timer = setTimeout(() => {
                //@ts-ignore
                if (typeof $.fn.foundation === "function") {
                    clearTimeout(timer);
                    //@ts-ignore
                    $(document).foundation();
                }
            }, 0);
            return () => clearTimeout(timer);
        }
        catch(e){
            //@ts-ignore
            photoOrg.clientLogger.error({description: "PROJECTS:projects_view:Foundation:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: e, err_stack: e.stack});
        }
      }, []);

    const getProductRedirectUrl = (product) => {
        let productUrl = product['url'];
        if(product.name === "link-to-prints"){
            //@ts-ignore
            return photoOrg.config.prints_builder_url + "?" + photoOrg.config.prints_sku_4x6 +"&flowFrom=myphotos";  
        }else{
            //@ts-ignore
            return photoOrg.config.store_url + productUrl;
        }
    }
    //@ts-ignore
    var productsList = photoOrg.config.product_details.products.map(function(product){
        let productUrl = getProductRedirectUrl(product);
        //@ts-ignore
        return <li role="none" key={product['name']}><a role="menuitem" href={productUrl} id={product['name']}>{photoOrg.translations.projects['action_container'][product['i18n_text_key']]}</a></li>
    })

    return(
        <ul id="hoverproducts" role="menu" className="right f-dropdown ib-dropdown-menu" aria-labelledby="product_links-button" data-dropdown-content>
            {productsList}
        </ul>
    )
}

export default ProductsDropdownComponent;